import React from 'react';
import { useTranslation } from 'react-i18next';
import { Delete, Edit, Restore } from '@mui/icons-material';
import { toast } from "react-toastify";
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { PRIVATE_USER_FORM_CONTACT_DELEGATION_SERVICE, PRIVATE_USER_LIST_DELEGATION_SERVICE, PRIVATE_USER_SERVICIOS_CONTRATADOS } from '../../../Constants/PathsConstants';
import { deleteServiceContactDelegationService } from '../../../../Domain/Services/ServiceContactDelegation/DeleteServiceContactDelegationService';
import { getServiceContactDelegationList } from '../../../../Domain/Services/ServiceContactDelegation/GetServiceContactDelegationListService';
import { patchServiceContactDelegationService } from '../../../../Domain/Services/ServiceContactDelegation/PatchServiceContactDelegationService';
import Loader from 'UI/Application/Components/Loaders/Loader';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper, TextField, Grid, Typography, Pagination, DialogTitle, DialogActions, Dialog, DialogContent, Tooltip, IconButton, Chip } from '@mui/material';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { GESTOR_DELEGACIONES_SERVICIOS, DELEGADO_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { getDelegationList } from 'Delegation/Domain/Services/GetDelegationListService';
import { ClearIcon } from '@mui/x-date-pickers';


function TableServiceContactDelegationView() {
    const { t } = useTranslation();
    const [sendingApiRequest, setSendingApiRequest] = React.useState(false);
    const [offset, setOffset] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [lastPage, setLastPage] = React.useState(1);
    const [ServiceContactDelegation, setServiceContactDelegation] = React.useState([]);
    const [loadServiceContactDelegation, setLoadServiceContactDelegation] = React.useState(true);
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [openRestoreModal, setOpenRestoreModal] = React.useState(false);
    const [selectedId, setSelectedId] = React.useState(null);
    const [filterDeleted, setFilterDeleted] = React.useState(0);
    const [open, setOpen] = React.useState(null);
    const [id, setId] = React.useState(null);
    const [delegacion, setDelegacion] = React.useState([]);
    const limit = 10;
    const [filterContractDelegationName, setFilterContractDelegationName] = React.useState('');
    const [filterServiceContactDelegationName, setFilterServiceContactDelegationName] = React.useState('');
    const [filterContactPhoneNumber, setFilterContactPhoneNumber] = React.useState('');
    const [filterContractDelegationDelegationName, setFilterContractDelegationDelegationName] = React.useState([]);
    const navigate = useNavigate();
    console.log(open, id);
    const { checkPermission } = useAuthContext();
    const [hasAdminPermission, setHasAdminPermission] = React.useState(false);
    const [hasDelegadoPermission, setHasDelegadoPermission] = React.useState(false);
    console.log(hasAdminPermission, hasDelegadoPermission);
    React.useEffect(() => {
        const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);
        const delegado = checkPermission(DELEGADO_DELEGACIONES_SERVICIOS);

        setHasAdminPermission(admin);
        setHasDelegadoPermission(delegado);
        if (!admin && !delegado) {
            navigate(PRIVATE_USER_LIST_DELEGATION_SERVICE, { replace: true });
        }

    }, [checkPermission, navigate]);

    const handleDelete = (id) => {
        setOpenDeleteModal(true);
        setSelectedId(id);
    };

    const handleConfirmDelete = () => {
        if (selectedId && !sendingApiRequest) {
            setSendingApiRequest(true);
            deleteServiceContactDelegationService(selectedId).then((response) => {
                if (response) {
                    setOpenDeleteModal(false);
                    setLoadServiceContactDelegation(true);
                    setSelectedId(null);
                    toast.success(t('serviceContactDelegation.table.modal.delete.done'));
                }
            }).catch((error) => {
                console.error("Error en el delte ", error);
                toast.error(t('serviceContactDelegation.table.modal.delete.error'));
            }).finally(() => {
                setSendingApiRequest(false);
            });
        }
    };

    const handleRestore = (id) => {
        setOpenRestoreModal(true);
        setSelectedId(id);
    };

    const handleConfirmRestore = () => {
        if (selectedId && !sendingApiRequest) {
            setSendingApiRequest(true);
            const serviceContactDelegationToRestore = ServiceContactDelegation.find(a => a.id === selectedId);
            if (!serviceContactDelegationToRestore) {
                toast.error(t('serviceContactDelegation.restore.error'));
                setSendingApiRequest(false);
                return;
            }
            patchServiceContactDelegationService(selectedId, {
                restore: true,
                name: serviceContactDelegationToRestore.name,
                apellido: serviceContactDelegationToRestore.apellido,
                correoElectronico: serviceContactDelegationToRestore.correoElectronico,
                contactPhoneNumber: serviceContactDelegationToRestore.contactPhoneNumber,
                serviceContractDelegationId: serviceContactDelegationToRestore.serviceContactDelegationId,
            }).then((response) => {
                if (response) {
                    setOpenRestoreModal(false);
                    setLoadServiceContactDelegation(true);
                    setSelectedId(null);
                    toast.success(t('serviceContactDelegation.restore.done'));
                }
            }).catch((error) => {
                console.error("Error en el restore ", error);
                toast.error(t('serviceContactDelegation.restore.error'));
            }).finally(() => {
                setSendingApiRequest(false);
            });
        }
    };

    const handleFilterDeletedChange = (event) => {
        setFilterDeleted(event.target.value);
        setLoadServiceContactDelegation(true);
    };

    const handleServiceContractDelegationNameChange = (event) => {
        setFilterContractDelegationName(event.target.value);
        setLoadServiceContactDelegation(true);
    };
    React.useEffect(() => {
        getDelegationList()
            .then((response) => {
                if (response && response.records) {
                    setDelegacion(response.records);
                }
            })
            .catch((error) => {
                console.error('Error al cargar delegaciones:', error);
            });
    }, []);
    const handleServiceContractDelegationDelegationNameChange = (event) => {
        const { value } = event.target;
        setFilterContractDelegationDelegationName(typeof value === 'string' ? value.split(',') : value);
        setLoadServiceContactDelegation(true);
    };

    const handleServiceContactNameChange = (event) => {
        setFilterServiceContactDelegationName(event.target.value);
        setLoadServiceContactDelegation(true);
    };

    const handlePhoneNumberChange = (event) => {
        setFilterContactPhoneNumber(event.target.value);
        setLoadServiceContactDelegation(true);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        setOffset((value - 1) * limit);
        setLoadServiceContactDelegation(true);
    };

    const handleOpenModalCreate = () => {
        console.log("Abriendo modal con ID: new");
        setId("new");
        setOpen(true);
    };

    React.useEffect(() => {
        if (loadServiceContactDelegation) {
            getServiceContactDelegationList({
                offset: offset,
                limit: limit,
                filterDeleted: filterDeleted,
                filterName: filterServiceContactDelegationName,
                filterContractDelegationName: filterContractDelegationName,
                filterContactPhoneNumber: filterContactPhoneNumber,
                filterContractDelegationDelegationName: filterContractDelegationDelegationName

            }).then((response) => {
                console.log("response from API", response);
                if (!response || !response.records) {
                    setServiceContactDelegation([]);
                    return;
                }
                setServiceContactDelegation(response.records);
                setLastPage(Math.ceil(response.total / limit));
                setLoadServiceContactDelegation(false);
            });
        }
    }, [loadServiceContactDelegation, offset, limit, filterDeleted, filterServiceContactDelegationName, filterContractDelegationName, filterContactPhoneNumber, filterContractDelegationDelegationName]);

    return (
        <>
            <Paper sx={{ margin: 0, padding: 0, display: 'flex', flexDirection: 'column', width: "100%" }}>

                <Box display="flex" alignItems="center" mb={1} paddingTop={1} paddingLeft={1}>
                    <IconButton size="small" onClick={() => navigate(PRIVATE_USER_SERVICIOS_CONTRATADOS)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="body2" sx={{ ml: 1, cursor: 'pointer' }} onClick={() => navigate(PRIVATE_USER_SERVICIOS_CONTRATADOS)}>Volver</Typography>
                </Box>
                {/* <NavigationBreadcrumbs /> */}
                <Typography variant="h4" sx={{ mb: 2, textAlign: "center" }}>
                    {t('serviceContactDelegation.table.title')}
                </Typography>

                {/* 🔹 Contenedor de filtros */}
                <Box sx={{ p: 2 }}>
                    <Grid container spacing={2} alignItems="flex-end" justifyContent="flex-start">
                        {/* filtro Contract Name */}

                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }}>
                                <TextField
                                    label={t('serviceContact.table.filter_by_name')}
                                    size='small'
                                    variant="outlined"
                                    value={filterContractDelegationName}
                                    onChange={handleServiceContractDelegationNameChange}
                                />
                            </FormControl>
                        </Grid>
                        {/*Filtro de Delegacion */}
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }} size='small'>
                                <InputLabel id='delegation-select-label'>
                                    {t('serviceContactDelegation.table.filter_by_name5')}
                                </InputLabel>
                                <Select
                                    labelId="delegation-select-label"
                                    multiple
                                    value={filterContractDelegationDelegationName}
                                    onChange={handleServiceContractDelegationDelegationNameChange}
                                    renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map((name) => (
                                                <Chip key={name} label={name} />
                                            ))}
                                        </Box>
                                    )}
                                    label={t('serviceContactDelegation.table.filter_by_name5')}
                                    endAdornment={
                                        filterContractDelegationDelegationName.length > 0 && (
                                            <IconButton
                                                size="small"
                                                sx={{ marginRight: 2 }}
                                                onClick={() => {
                                                    setFilterContractDelegationDelegationName([]);
                                                    setLoadServiceContactDelegation(true);
                                                }} // Limpia el estado
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )
                                    }
                                >
                                    {[...delegacion]
                                        .sort((a, b) => a.name.localeCompare(b.name)) // Orden alfabético
                                        .map((item) => (
                                            <MenuItem key={item.id} value={item.name}>
                                                {item.name}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* filtro Service Contact Delegation Name */}
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }}>
                                <TextField
                                    label={t('serviceContactDelegation.table.filter_by_name4')}
                                    size='small'
                                    variant="outlined"
                                    value={filterServiceContactDelegationName}
                                    onChange={handleServiceContactNameChange}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }}>
                                <TextField
                                    label={t('serviceContactDelegation.table.filter_by_name3')}
                                    size='small'
                                    variant="outlined"
                                    value={filterContactPhoneNumber}
                                    onChange={handlePhoneNumberChange}
                                />
                            </FormControl>
                        </Grid>

                        {/* filtro Deleted */}

                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }} size='small'>
                                <InputLabel id="filter-deleted-label">
                                    {t('serviceContactDelegation.table.filter_by_name_2')}
                                </InputLabel>
                                <Select
                                    labelId='filter-deleted-label'
                                    id='filter-deleted'
                                    label={t('serviceContactDelegation.table.filter_by_name_2')}
                                    value={filterDeleted}
                                    onChange={handleFilterDeletedChange}
                                >
                                    <MenuItem value={0}>{t('serviceContactDelegation.table.filter_by_not_deleted')}</MenuItem>
                                    <MenuItem value={1}>{t('serviceContactDelegation.table.filter_by_deleted')}</MenuItem>
                                    <MenuItem value={2}>{t('serviceContactDelegation.table.filter_by_all')}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* Botones */}

                    {/* Boton crear un Contract Delegation */}
                    <br />
                    {hasAdminPermission && (

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, mr: 2 }}>

                            <Button
                                variant="contained"
                                component={RouterLink}
                                to={PRIVATE_USER_FORM_CONTACT_DELEGATION_SERVICE + "/new"}
                                startIcon={<AddIcon />}
                                sx={{
                                    backgroundColor: "green",
                                    color: "white",
                                    fontWeight: "bold",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    "&:hover": { backgroundColor: "#008f39" }
                                }}
                                onClick={handleOpenModalCreate}
                            >
                                {t('serviceContactDelegation.form.create')}
                            </Button>
                        </Box>
                    )}




                    {/* Tabla Contract Delegation */}
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: "100%" }} arial-label=" service contact delegation table">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#0492D4' }}>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContactDelegation.table.Contract')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContactDelegation.table.ContractDelegation')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContactDelegation.table.name')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContactDelegation.table.apellido')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContactDelegation.table.correoElectronico')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContactDelegation.table.phoneNumber')}
                                    </TableCell>
                                    {hasAdminPermission && (
                                        <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
                                            {t('serviceContactDelegation.table.actions')}
                                        </TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loadServiceContactDelegation ? (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center">
                                            <Loader />
                                        </TableCell>
                                    </TableRow>
                                ) : ServiceContactDelegation.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">
                                            <Typography variant="subtitle1">
                                                {t('serviceContractDelegation.table.no_data')}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    //accciones
                                    ServiceContactDelegation.map((serviceContactDelegation) => (
                                        console.log(serviceContactDelegation),
                                        <TableRow key={serviceContactDelegation.id}>
                                            <TableCell align='center'>
                                                {serviceContactDelegation.serviceContractDelegation.name}
                                            </TableCell>
                                            <TableCell align='center'>
                                                {serviceContactDelegation.serviceContractDelegation.delegationName}
                                            </TableCell>
                                            <TableCell align='center'>{serviceContactDelegation.name}</TableCell>
                                            <TableCell align='center'>{serviceContactDelegation.apellido}</TableCell>
                                            <TableCell align='center'>{serviceContactDelegation.correoElectronico}</TableCell>
                                            <TableCell align='center'>
                                                {serviceContactDelegation.contactPhoneNumber}
                                            </TableCell>
                                            {hasAdminPermission && (
                                                <TableCell align='center'>{serviceContactDelegation.deletedAt === null ? (
                                                    <>
                                                        <Tooltip title={t('serviceContactDelegation.table.actions.edit')}>
                                                            <IconButton component={RouterLink} to={PRIVATE_USER_FORM_CONTACT_DELEGATION_SERVICE + "/" + serviceContactDelegation.id}>
                                                                <Edit color="metal" />
                                                            </IconButton>
                                                        </Tooltip>

                                                        <Tooltip title={t('serviceContactDelegation.table.actions.delete')}>
                                                            <IconButton onClick={() => { handleDelete(serviceContactDelegation.id) }}>
                                                                <Delete color="error" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Tooltip title={t('unionDelegationService.table.modal.restore.title')}>
                                                            <IconButton onClick={() => handleRestore(serviceContactDelegation.id)}>
                                                                <Restore color="success" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                )}
                                                </TableCell>

                                            )}
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Paper>

            {/* Paginacion */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Pagination count={lastPage} page={currentPage} onChange={handlePageChange} />
            </Box>

            {/* Modal de confirmacion de eliminacion */}
            <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
                <DialogTitle>{t('serviceContactDelegation.table.modal.delete.title')}</DialogTitle>
                <DialogContent>
                    <Typography variant="body1">{t('serviceContactDelegation.table.modal.delete.phrase')}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={() => setOpenDeleteModal(false)}>
                        {t('serviceContactDelegation.table.modal.delete.button.cancel')}
                    </Button>
                    <Button variant="contained" color="error" onClick={handleConfirmDelete}>
                        {t('serviceContactDelegation.table.modal.delete.button.delete')}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modal de restauracion */}
            <Dialog open={openRestoreModal} onClose={() => setOpenRestoreModal(false)}>
                <DialogTitle>{t('serviceContactDelegation.table.modal.restore.title')}</DialogTitle>
                <DialogContent>
                    <Typography variant="body1">{t('serviceContactDelegation.table.modal.restore.phrase')}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={() => setOpenRestoreModal(false)}>
                        {t('serviceContactDelegation.table.modal.restore.button.cancel')}
                    </Button>
                    <Button variant="contained" color="success" onClick={handleConfirmRestore}>
                        {t('serviceContactDelegation.table.actions.restore')}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* 🔹 Loader para evitar dobles peticiones */}
            <DialogLoader open={sendingApiRequest} />
        </>
    );

}

export default TableServiceContactDelegationView;